export const PageTabs = {
  Providers: 0,
  Services: 1,
};

export const PageTabsOptions = [
  {
    label: 'Providers',
    value: 0,
  },
  {
    label: 'Services',
    value: 1,
  },
];
